export enum FeatureFlagVariables {
  isBonusxUser = "is_bonusx_user",
  isElevenLabsWidgetAvailable = "is_eleven_labs_widget_available",
  iseeUniqueIdentifier = "isee_unique_identifier",
  isUpgradeFirstEnabled = "is_subscribe_first_enabled",
  upgradeFirstProductIds = "subscribe_first_product_ids",
  dynamicPaywallProductId = "dynamic_paywall_product_id",
  isIncomeAvailable = "is_income_available",
  isRealEstatesAvailable = "is_real_estates_available",
  isAdminRedirectActive = "is_admin_redirect_active",
  aiDocumentValidationEnabledStructures = "ai_document_validation_enabled_structures",
  confermaRequisitiExperimentVariant = "conferma_requisiti_experiment_variant",
}
